function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('[id^="Details-"]');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('.summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('[data-open="true"]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('.summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.dataset.open;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    event.preventDefault();

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        detailsElement.dataset.open = true;
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('[id^="Details-"]').forEach(details => {
      details.dataset.open = true;
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.dataset.open = true && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('[id^="Details-"]');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.dataset.open = 'false';
    detailsElement.removeAttribute('open');
    detailsElement.querySelector('.summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('.summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.dataset.open = 'false';
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('[data-open="true"]')) {
          trapFocus(detailsElement.closest('[data-open="true"]'), detailsElement.querySelector('.summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

// class HeaderDrawer extends MenuDrawer {
//   constructor() {
//     super();
//   }

//   openMenuDrawer(summaryElement) {
//     this.header = this.header || document.querySelector('.section-header');
//     this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
//     document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
//     this.header.classList.add('menu-open');

//     setTimeout(() => {
//       this.mainDetailsToggle.classList.add('menu-opening');
//     });

//     summaryElement.setAttribute('aria-expanded', true);
//     trapFocus(this.mainDetailsToggle, summaryElement);
//     document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
//   }

//   closeMenuDrawer(event, elementToFocus) {
//     super.closeMenuDrawer(event, elementToFocus);
//     this.header.classList.remove('menu-open');
//   }
// }


class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.isMobile = false;

    this._handleToggleClick = this._handleToggleClick.bind(this);
    this._handleOutsideClick = this._handleOutsideClick.bind(this);
    this._handleKeydown = this._handleKeydown.bind(this);
    this._updateDrawerPosition = this._updateDrawerPosition.bind(this);
    this._handleExpandEnd = this._handleExpandEnd.bind(this);
    this._handleCollapseEnd = this._handleCollapseEnd.bind(this);
  }

  connectedCallback() {
    this.stickyHeader =
      this.closest('sticky-header') ||
      document.querySelector('sticky-header');

    this.header =
      this.closest('.header') ||
      document.querySelector('.header');

    this.toggleBtn = this.querySelector('.header__icon--summary');
    this.drawer = this.querySelector('.menu-drawer');

    if (!this.header || !this.toggleBtn || !this.drawer) return;

    this._setupBreakpointObserver();

    this.toggleBtn.addEventListener(
      'click',
      this._handleToggleClick
    );
  }

  disconnectedCallback() {
    this.toggleBtn?.removeEventListener(
      'click',
      this._handleToggleClick
    );

    this._breakpointResizeObserver?.disconnect();
    this._breakpointResizeObserver = null;

    this._teardownOpenListeners();

    // bodyに残ったスクロールロックを確実に解除
    document.body.classList.remove('overflow-hidden-mobile');
  }

  // ========================================
  // ブレイクポイント監視
  // ========================================

  _setupBreakpointObserver() {
    const breakpoint = 1280;

    const updateBreakpoint = (width) => {
      const wasMobile = this.isMobile;

      this.isMobile = width < breakpoint;

      // スマホ → PCへ切り替わった場合は閉じる
      if (wasMobile && !this.isMobile) {
        this.close();
      }

      // PC状態になったらbodyのスクロールロックも解除
      if (!this.isMobile) {
        document.body.classList.remove(
          'overflow-hidden-mobile'
        );
      }
    };

    this._breakpointResizeObserver = new ResizeObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry) return;

        updateBreakpoint(entry.contentRect.width);
      }
    );

    this._breakpointResizeObserver.observe(this.header);

    // 初期状態を即座に判定
    updateBreakpoint(
      this.header.getBoundingClientRect().width
    );
  }

  // ========================================
  // ドロワーを開く
  // ========================================

  open() {
    if (!this.isMobile) return;

    const drawer = this.drawer;

    const headerBottom =
      this.header.getBoundingClientRect().bottom;

    const headerHeight =
      this.stickyHeader?.headerBounds?.height ||
      this.header.getBoundingClientRect().height;

    const targetHeight =
      window.innerHeight - headerHeight;

    drawer.style.top = `${headerBottom - 4}px`;
    drawer.style.visibility = 'visible';
    drawer.style.overflowY = 'hidden';
    drawer.style.height = '0px';

    this._openTargetHeight = targetHeight;

    drawer.removeEventListener(
      'transitionend',
      this._handleCollapseEnd
    );

    drawer.classList.add('menu-drawer--is-open');
    this.classList.add('menu-opening');

    this.toggleBtn.setAttribute(
      'aria-expanded',
      'true'
    );

    drawer.removeAttribute('tabindex');

    document.body.classList.add(
      'overflow-hidden-mobile'
    );

    requestAnimationFrame(() => {
      drawer.style.height = `${targetHeight}px`;
    });

    drawer.addEventListener(
      'transitionend',
      this._handleExpandEnd
    );

    this._setupOpenListeners();
  }

  // ========================================
  // ドロワーを閉じる
  // ========================================

  close() {
    const drawer = this.drawer;

    // まずbodyのスクロールロックを確実に解除
    document.body.classList.remove(
      'overflow-hidden-mobile'
    );

    this.classList.remove('menu-opening');

    this.toggleBtn?.setAttribute(
      'aria-expanded',
      'false'
    );

    this._teardownOpenListeners();

    // すでに閉じている場合
    if (!drawer.classList.contains('menu-drawer--is-open')) {
      drawer.style.height = '0px';
      drawer.style.overflowY = 'hidden';
      drawer.setAttribute('tabindex', '-1');

      return;
    }

    const currentHeight =
      drawer.getBoundingClientRect().height;

    drawer.style.overflowY = 'hidden';
    drawer.style.height = `${currentHeight}px`;

    // 現在の高さを確定
    void drawer.offsetHeight;

    drawer.removeEventListener(
      'transitionend',
      this._handleExpandEnd
    );

    drawer.addEventListener(
      'transitionend',
      this._handleCollapseEnd
    );

    requestAnimationFrame(() => {
      drawer.style.height = '0px';
    });

    drawer.classList.remove(
      'menu-drawer--is-open'
    );

    drawer.setAttribute('tabindex', '-1');
  }

  // ========================================
  // 開くアニメーション終了
  // ========================================

  _handleExpandEnd(event) {
    if (event.propertyName !== 'height') return;

    const drawer = this.drawer;

    if (!drawer.classList.contains('menu-drawer--is-open')) {
      return;
    }

    const targetHeight =
      this._openTargetHeight || 0;

    drawer.style.overflowY =
      drawer.scrollHeight > targetHeight
        ? 'auto'
        : 'hidden';

    drawer.removeEventListener(
      'transitionend',
      this._handleExpandEnd
    );
  }

  // ========================================
  // 閉じるアニメーション終了
  // ========================================

  _handleCollapseEnd(event) {
    if (event.propertyName !== 'height') return;

    const drawer = this.drawer;

    drawer.style.visibility = 'hidden';
    drawer.style.overflowY = 'hidden';
    drawer.style.height = '0px';

    drawer.removeEventListener(
      'transitionend',
      this._handleCollapseEnd
    );

    // 念のためbodyのスクロールロックを解除
    document.body.classList.remove(
      'overflow-hidden-mobile'
    );
  }

  // ========================================
  // 開いている間のリスナー
  // ========================================

  _setupOpenListeners() {
    // 重複登録防止
    this._teardownOpenListeners();

    document.addEventListener(
      'click',
      this._handleOutsideClick,
      true
    );

    document.addEventListener(
      'keydown',
      this._handleKeydown
    );

    window.addEventListener(
      'resize',
      this._updateDrawerPosition
    );

    window.addEventListener(
      'scroll',
      this._updateDrawerPosition,
      { passive: true }
    );

    if ('ResizeObserver' in window) {
      this._headerResizeObserver =
        new ResizeObserver(
          this._updateDrawerPosition
        );

      this._headerResizeObserver.observe(
        this.header
      );
    }
  }

  // ========================================
  // リスナー解除
  // ========================================

  _teardownOpenListeners() {
    document.removeEventListener(
      'click',
      this._handleOutsideClick,
      true
    );

    document.removeEventListener(
      'keydown',
      this._handleKeydown
    );

    window.removeEventListener(
      'resize',
      this._updateDrawerPosition
    );

    window.removeEventListener(
      'scroll',
      this._updateDrawerPosition
    );

    this._headerResizeObserver?.disconnect();
    this._headerResizeObserver = null;
  }

  // ========================================
  // ドロワー位置・高さ更新
  // ========================================

  _updateDrawerPosition() {
    if (!this.isMobile) return;

    const drawer = this.drawer;

    const headerHeight =
      this.stickyHeader?.headerBounds?.height ||
      this.header.getBoundingClientRect().height;

    const headerBottom =
      this.header.getBoundingClientRect().bottom;

    drawer.style.top =
      `${headerBottom - 4}px`;

    if (
      !drawer.classList.contains(
        'menu-drawer--is-open'
      )
    ) {
      return;
    }

    const targetHeight =
      window.innerHeight - headerHeight;

    this._openTargetHeight = targetHeight;

    drawer.style.height =
      `${targetHeight}px`;

    drawer.style.overflowY =
      drawer.scrollHeight > targetHeight
        ? 'auto'
        : 'hidden';
  }

  // ========================================
  // 開閉ボタン
  // ========================================

  _handleToggleClick(event) {
    event.preventDefault();

    if (!this.isMobile) return;

    if (
      this.drawer.classList.contains(
        'menu-drawer--is-open'
      )
    ) {
      this.close();
    } else {
      this.open();
    }
  }

  // ========================================
  // 外側クリック
  // ========================================

  _handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  // ========================================
  // ESCキー
  // ========================================

  _handleKeydown(event) {
    if (event.key !== 'Escape') return;

    this.close();
    this.toggleBtn?.focus();
  }
}

customElements.define(
  'header-drawer',
  HeaderDrawer
);



class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.currentContent = null;
    this.currentTrigger = null;
  }


  connectedCallback() {
    this.header = this.closest('.header');
    this.stickyHeader = this.closest('sticky-header');
    this.menuItems = this.querySelectorAll('.js-header__menu-button');

    // overlayはbody直下に1つだけ生成する
    this.overlay = document.createElement('div');
    this.overlay.className = 'mega-menu-overlay';
    this.stickyHeader.after(this.overlay);

    this.menuItems.forEach((item) => {
      item.addEventListener('click', (e) => this.onMenuItemClick(item, e));
    });

    this._onDocumentClick = this.onDocumentClick.bind(this);
    this._onKeydown = this.onKeydown.bind(this);
    this._onResize = this.onResize.bind(this);

    document.addEventListener('click', this._onDocumentClick);
    document.addEventListener('keydown', this._onKeydown);
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocumentClick);
    document.removeEventListener('keydown', this._onKeydown);
    window.removeEventListener('resize', this._onResize);
    if (this.overlay) this.overlay.remove();
  }

  onMenuItemClick(item, e) {
    e.preventDefault(); // メガメニューのトリガーとして使うのでページ遷移をキャンセル
    const wrapper = item.closest('.mega-menu');
    const content = wrapper.querySelector('.mega-menu__content');

    if (this.currentContent === content) {
      this.close(); // 開いている項目を再クリック → 閉じる
    } else {
      this.open(content, item);
    }
  }

  open(content, trigger) {
    if (this.currentContent && this.currentContent !== content) {
      this.close();
    }
    content.classList.add('is-open');
    // 実際の高さを測ってmax-heightに設定することでアコーディオンアニメーションさせる
    content.style.maxHeight = content.scrollHeight + 'px';
    trigger.classList.add('is-active');
    this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    this.currentContent = content;
    this.currentTrigger = trigger;
  }

  close() {
    if (!this.currentContent) return;
    this.currentContent.style.maxHeight = '0px';
    this.currentContent.classList.remove('is-open');
    if (this.currentTrigger) this.currentTrigger.classList.remove('is-active');
    this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    this.currentContent = null;
    this.currentTrigger = null;
  }

  onDocumentClick(e) {
    if (!this.currentContent) return;
    const clickedInsideHeader = this.header ? this.header.contains(e.target) : this.contains(e.target);
    const clickedInsideMenu = this.currentContent.contains(e.target);
    if (!clickedInsideHeader && !clickedInsideMenu) {
      this.close();
    }
  }

  onKeydown(e) {
    if (e.key === 'Escape') this.close();
  }

  onResize() {
    if (this.currentContent) {
      this.currentContent.style.maxHeight = this.currentContent.scrollHeight + 'px';
    }
  }
}
customElements.define('mega-menu', MegaMenu);






class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    const resizeObserver = new ResizeObserver(this.updateDetailsOnWidthChange.bind(this));
    resizeObserver.observe(document.body);
    document.addEventListener('DOMContentLoaded', () => {
      this.updateDetailsOnWidthChange([{ contentRect: { width: window.innerWidth } }]);
    });

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    // console.log(this.currentPage + this.sliderItemsLessNum + "：currentPage");
    // console.dir(this.sliderItemsToShow);
// const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      const slideScrollPosition = this.currentPage + this.sliderItemsLessNum === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
  }

  updateDetailsOnWidthChange(entries) {
  entries.forEach((entry) => {
    const currentWidth = entry.contentRect.width;

      if (currentWidth >= 900) {
        if(this.sliderItems.length > 3 ){
          this.sliderItemsLessNum = parseInt(3);
        }else{
          this.sliderItemsLessNum = parseInt(0);
        }
      } else {
        this.sliderItemsLessNum = parseInt(1);
      }

  });
}

  

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);


const FLANGECUP_COLORS = {
  putty: {
    aliases: ['putty'],
    cone: 'flangecup-cone-putty',
    cone02: null,
    etch: null,
    semicircle: null,
    hikkake: 'flangecup-hikkake-black',
  },
  kelp: {
    aliases: ['kelp'],
    cone: 'flangecup-cone-kelp',
    cone02: null,
    etch: null,
    semicircle: null,
    hikkake: 'flangecup-hikkake-black',
  },
  silver: {
    aliases: ['steel', 'stainless steel', 'silver'],
    cone: 'flangecup-cone-black',
    cone02: null,
    etch: 'flangecup-etch-silver',
    semicircle: null,
    hikkake: null,
  },
  black: {
    aliases: ['black'],
    cone: 'flangecup-cone-black',
    cone02: 'flangecup-cone02-black',
    etch: null,
    semicircle: null,
    hikkake: 'flangecup-hikkake-black',
  },
  chrome: {
    aliases: ['nickel', 'chrome', 'smoke', 'opal'],
    cone: 'flangecup-cone-chrome',
    cone02: null,
    etch: null,
    semicircle: 'flangecup-semicircle-chrome',
    hikkake: 'flangecup-hikkake-chrome',
  },
  copper: {
    aliases: ['copper'],
    cone: null,
    cone02: null,
    etch: 'flangecup-etch-copper',
    semicircle: 'flangecup-semicircle-copper',
    hikkake: 'flangecup-hikkake-copper',
  },
  gold: {
    aliases: ['gold', 'bronze'],
    cone: null,
    cone02: null,
    etch: null,
    semicircle: 'flangecup-semicircle-gold',
    hikkake: 'flangecup-hikkake-gold',
  },
  white: {
    aliases: ['white'],
    cone: 'flangecup-cone-white',
    cone02: 'flangecup-cone02-white',
    etch: null,
    semicircle: null,
    hikkake: 'flangecup-hikkake-white',
  },
  brass: {
    aliases: ['brass'],
    cone: null,
    cone02: null,
    etch: 'flangecup-etch-brass',
    semicircle: 'flangecup-semicircle-brass',
    hikkake: null,
  },
};
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('load', this.loadVariant());
    this.addEventListener('change', this.onVariantChange);
  }

  loadVariant() {
    this.updateOptions();
    this.updateMasterId();
    this.setVariant();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateFlangecupOption1();
      this.updateFlangecupOption2();
      this.updateShareUrl();
    }
  }

  setVariant() {
    if (!this.currentVariant) return;
    const data = this.getComingsoonData();
    const item = data.find(item => item.id === this.currentVariant.id);
    const soon = item?.soon;
    const buttonText = soon !== 'false' ? soon : window.variantStrings.soldOut;
    this.toggleAddButton(!this.currentVariant.available, buttonText);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) =>
      variant.options.every((option, index) => this.options[index] === option)
    );
  }
  
  // updateFlangecupOption2() {
  //   if (!this.currentVariant.option2) return;
  //   if (!document.querySelector('.flangecup-jp')) return;
  //   const flangecup = this.currentVariant.option2.toLowerCase();
  //   document.querySelector('.flangecup__text-jp').innerHTML = flangecup;
  //   document.querySelector('.flangecup__img-jp').src = document.querySelector('.flangecup__img-jp').src.replace(/(white|black)/, flangecup);
  // }
  normalizeFlangecupColor(value) {
    const color = String(value ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
    for (const [key, config] of Object.entries(FLANGECUP_COLORS)) {
      if (config.aliases.some(alias => alias.toLowerCase() === color)) { return key; }
    }
    return color;
  }
  getFlangecupColor() {
    const key = this.normalizeFlangecupColor( this.currentVariant?.option1 );

    return {
      key,
      config: FLANGECUP_COLORS[key] ?? {
        label: key,
        image: key
      }
    };
  }
  updateFlangecupOption1() {
    if (!document.querySelector('.flangecup-no-jp')) return;
    const text = document.querySelector('.flangecup__text-no-jp');
    const img = document.querySelector('.flangecup__img-no-jp');
    if (!text || !img) return;

    const { config } = this.getFlangecupColor();
    console.dir(config);
    const flangecupArg = this.currentVariant.option1.toLowerCase().replace(/stainless /, '');
    const chrome = /(chrome|silver|nickel)/;
    const flangecup = chrome.test(flangecupArg) ? flangecupArg.replace(chrome, 'chrome') :  flangecupArg ;
    if (text) text.textContent = flangecup;
    img.src = img.src.replace(/(white|black|brass|steel|copper|smoke|gold|chrome|silver|opal|bronze|kelp|putty|putty|nickel)/, flangecup);
  }
  updateFlangecupOption2() {
    if (!document.querySelector('.hikkake')) return;
    if (!document.querySelector('.flangecup__img-jp')) return;
    const text = document.querySelector('.flangecup__text-jp');
    const img = document.querySelector('.flangecup__img-jp');
    if (!text || !img) return;

    const { config } = this.getFlangecupColor();
    console.dir(config);

    const flangecupArg = this.currentVariant.option1.toLowerCase().replace(/stainless /, '');
    const chrome = /(steel|smoke|chrome|opal|silver|nickel)/;
    const black = /(black|kelp|putty)/;
    const flangecup = chrome.test(flangecupArg) ? flangecupArg.replace(chrome, 'chrome') : black.test(flangecupArg) ? flangecupArg.replace(black, 'black') :  flangecupArg ;
    if (text) text.textContent = flangecup;
    img.src = img.src.replace(/(black|copper|gold|chrome|bronze|nickel)/, flangecup);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="SwiperMediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach( mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true) );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }


  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  async renderProductInfo() {
    const variant = this.currentVariant;
    if (!variant) return;
    this.productInfoController?.abort();
    const controller = new AbortController();
    this.productInfoController = controller;
    const sectionId = this.dataset.originalSection || this.dataset.section;

    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.set('variant', variant.id);
    url.searchParams.set('section_id', sectionId);
    try {
      const response = await fetch(url, {signal: controller.signal});
      if (!response.ok) {throw new Error(`HTTP ${response.status}`);}

      const responseText = await response.text();
      if (this.productInfoController !== controller) return;

      const html = new DOMParser().parseFromString(responseText,'text/html');
      const destination = document.getElementById(`price-${this.dataset.section}`);
      const source = html.getElementById(`price-${sectionId}`);

      if (source && destination) {
        destination.innerHTML = source.innerHTML;
        destination.classList.remove('visibility-hidden');
      }

      const item = this.getComingsoonData().find( (item) => String(item.id) === String(variant.id) );

      const soon = item?.soon;
      const buttonText = soon !== 'false' ? soon : window.variantStrings.soldOut;
      this.toggleAddButton(!variant.available, buttonText);
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('商品情報の更新に失敗しました:', error);
    }
    // fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const html = new DOMParser().parseFromString(responseText, 'text/html')
    //     const destination = document.getElementById(`price-${this.dataset.section}`);
    //     const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
    //     const data = this.getComingsoonData();
    //     const item = data.find(item => item.id === this.currentVariant.id);
    //     const soon = item?.soon;
        

    //     if (source && destination) destination.innerHTML = source.innerHTML;

    //     const price = document.getElementById(`price-${this.dataset.section}`);

    //     if (price) price.classList.remove('visibility-hidden');
    //     console.dir(destination.innerHTML);
    //     const buttonText = soon !== 'false' ? soon : window.variantStrings.soldOut;
    //     this.toggleAddButton(!this.currentVariant.available, buttonText);
    //   });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    // console.dir(this);

    if ( text && text !== window.variantStrings.soldOut ) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = text;
    } else if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if(text){
        addButtonText.textContent = text;
      }else if(addButton.dataset.soon === 'true') {
        addButtonText.textContent = window.variantStrings.comingSoon;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
  

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    // console.log(this.variantData);
    return this.variantData;
  }
  getComingsoonData() {
    this.ComingsoonData = this.ComingsoonData || JSON.parse(this.querySelector('#comingsoon').textContent);
    // console.dir(this.ComingsoonData);
    return this.ComingsoonData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);







class ProductCardSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const el = this.querySelector('.swiper');
    const slides = this.querySelectorAll('.swiper-slide');
    if (!el || slides.length <= 1 || typeof Swiper === 'undefined') return;

    this.swiper = new Swiper(el, {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 500,
      loop: true,
      pagination: false,
      navigation: {
        prevEl: this.querySelector('.product-card-slider__button--prev'),
        nextEl: this.querySelector('.product-card-slider__button--next')
      },
      allowTouchMove: true,
      simulateTouch: false
    });

    this.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'mouse') return;
      this.swiper.slideToLoop(1);
    });

    this.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse') return;
      this.swiper.slideToLoop(0);
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy();
  }
}

if (!customElements.get('product-card-slider')) {
  customElements.define('product-card-slider', ProductCardSlider);
}




// document.addEventListener('DOMContentLoaded', () => {
//   const images = document.querySelectorAll('.image-loader:has(>[loading="lazy"]) img') || document.querySelectorAll('.image-loader > video');
//   const videos = document.querySelectorAll('.image-loader > video');
//   console.dir(images);

//   const observer = new IntersectionObserver((entries, observer) => {
//     entries.forEach((entry) => {
//       if (!entry.isIntersecting) return;

//       const media = entry.target;
//       const loader = media.closest('.image-loader');

//       const loaded = () => {
//         loader?.classList.add('is-loaded');
//         observer.unobserve(media);
//       };

//       if (media.tagName === 'VIDEO') {
//         if (media.readyState >= 2) {
//           loaded();
//         } else {
//           media.addEventListener('loadeddata', loaded, { once: true });
//         }
//       } else {
//         if (media.complete) {
//           loaded();
//         } else {
//           media.addEventListener('load', loaded, { once: true });
//         }
//       }
//     });
//   }, {
//     rootMargin: '200px 0px'
//   });

//   images.forEach((media) => observer.observe(media));
//   videos.forEach((media) => observer.observe(media));
// });


class LazyImage extends HTMLElement {
  connectedCallback() {
    if (this.dataset.lazyInitialized === 'true') return;

    const media = this.querySelector(':scope > img, :scope > video');

    if (!media) return;

    this.dataset.lazyInitialized = 'true';

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        this.observeMedia(media);
      },
      {
        rootMargin: '200px 0px'
      }
    );

    this.observer.observe(media);
  }

  observeMedia(media) {
    const loaded = () => {
      this.classList.add('is-loaded');
      this.observer?.unobserve(media);
    };

    if (media.complete && media.naturalWidth > 0) {
      loaded();
    } else {
      media.addEventListener('load', loaded, { once: true });
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}
customElements.define('lazy-image', LazyImage);




class LazyVideo extends HTMLElement {
  connectedCallback() {
    if (this.dataset.lazyInitialized === 'true') return;

    const media = this.querySelector(':scope > video');

    if (!media) return;

    this.dataset.lazyInitialized = 'true';

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        this.observeMedia(media);
      },
      {
        rootMargin: '200px 0px'
      }
    );

    this.observer.observe(media);
  }

  observeMedia(media) {
    const loaded = () => {
      this.classList.add('is-loaded');
      this.observer?.unobserve(media);
    };

    if (media.readyState >= 2) {
      loaded();
    } else {
      media.addEventListener('loadeddata', loaded, { once: true });
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}
customElements.define('lazy-video', LazyVideo);






class ScrollX extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.buttons = this.querySelector('.collection-buttons');

    if (!this.buttons) return;

    this.createArrows();
    this.updateArrows();

    this.buttons.addEventListener('scroll', () => this.updateArrows(), { passive: true });

    this.resizeObserver = new ResizeObserver(() => this.updateArrows());
    this.resizeObserver.observe(this.buttons);
  }

  createArrows() {
    this.prevButton = document.createElement('span');
    this.nextButton = document.createElement('span');

    this.prevButton.className = 'collection-scroll__arrow collection-scroll__arrow--prev';
    this.nextButton.className = 'collection-scroll__arrow collection-scroll__arrow--next';


    this.container.append(this.prevButton, this.nextButton);

    this.prevButton.addEventListener('click', () => {
      this.buttons.scrollBy({
        left: -this.buttons.clientWidth * 0.8,
        behavior: 'smooth'
      });
    });

    this.nextButton.addEventListener('click', () => {
      this.buttons.scrollBy({
        left: this.buttons.clientWidth * 0.8,
        behavior: 'smooth'
      });
    });
  }

  updateArrows() {
    const { scrollLeft, scrollWidth, clientWidth } = this.buttons;
    const maxScroll = scrollWidth - clientWidth;
    const threshold = 2;

    const isScrollable = maxScroll > threshold;
    const isStart = scrollLeft <= threshold;
    const isEnd = scrollLeft >= maxScroll - threshold;

    this.prevButton.hidden = !isScrollable || isStart;
    this.nextButton.hidden = !isScrollable || isEnd;
  }
}
customElements.define('scroll-x', ScrollX);














class CollectionBreadcrumbTracker extends HTMLElement {
  connectedCallback() {
    this.handleClick = this.handleClick.bind(this);
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    const link = event.target.closest('a[href*="/products/"]');
    if (!link || !this.contains(link)) return;

    const match = location.pathname.match(/^\/collections\/[^/]+/);
    if (!match) return;

    sessionStorage.setItem('lastProductCollection', match[0]);
  }
}

class ProductBreadcrumb extends HTMLElement {
  connectedCallback() {
    this.filterBreadcrumb();
  }

  filterBreadcrumb() {
    const breadcrumb = this.querySelector('.breadcrumb');
    if (!breadcrumb) return;

    const collectionPath = sessionStorage.getItem(
      'lastProductCollection'
    );

    const lists = [
      ...breadcrumb.querySelectorAll('.breadcrumb__list')
    ];

    if (!lists.length) return;

    if (!collectionPath) {
      lists.slice(1).forEach(list => list.remove());
      return;
    }

    const normalize = path =>
      path.replace(/\/+$/, '');

    const targetPath = normalize(collectionPath);

    const matchedList = lists.find(list =>
      [...list.querySelectorAll('a')].some(link => {
        const url = new URL(link.href, location.origin);

        return normalize(url.pathname) === targetPath;
      })
    );

    if (matchedList) {
      lists.forEach(list => {
        if (list !== matchedList) {
          list.remove();
        }
      });
    } else {
      lists.slice(1).forEach(list => list.remove());
    }
  }
}

customElements.define('collection-breadcrumb-tracker',CollectionBreadcrumbTracker);

customElements.define('product-breadcrumb',ProductBreadcrumb);